'use client';

import { Sparkles } from 'lucide-react';

export const AdvisorAssistantAvatar = () => (
  <div className="mr-2.5 mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-primary/10">
    <Sparkles className="h-3 w-3 text-primary" />
  </div>
);
